export default "__VITE_ASSET__9xLINoX5__"